<template>
    <div id="Content">
        <HomePage
            v-if="pageOne"
            :apiData="apiData"
            ref="homePage"
            @form-validity="handleFormValidity"
        />
        <AboutSupsis v-if="false" />
        <SystemOptions v-if="pageTwo" />
        <ModuleSelectorOne v-if="pageThree" />
        <ModuleSelectorTwo v-if="pageFour" />
        <SurveyQuestions v-if="pageFive" />
        <!--        <AboutSupsis v-if="pageTwo" />-->
        <!--        <SystemOptions v-if="pageThree" />-->
        <!--        <ModuleSelectorOne v-if="pageFour" />-->
        <!--        <ModuleSelectorTwo v-if="pageFive" />-->
        <!--        <SurveyQuestions v-if="pageSix" />-->
    </div>
</template>
<script>
import HomePage from "./page/HomePage.vue";
import AboutSupsis from "./page/AboutSupsis.vue";
import SystemOptions from "./page/SystemOptions.vue";
import ModuleSelectorOne from "./page/ModuleSelectorOne.vue";
import ModuleSelectorTwo from "./page/ModuleSelectorTwo.vue";
import SurveyQuestions from "./page/SurveyQuestions.vue";
import { formData, loadFromLocalStorage, saveToLocalStorage } from "../../utils/formStore";

export default {
    name: "ContentItem",
    props: {
        apiData: {
            type: Object,
            required: true,
        },
    },
    components: {
        HomePage,
        AboutSupsis,
        SystemOptions,
        ModuleSelectorOne,
        ModuleSelectorTwo,
        SurveyQuestions,
    },
    data() {
        return {
            pageOne: true,
            pageTwo: false,
            pageThree: false,
            pageFour: false,
            pageFive: false,
            pageSix: false,
            currentPage: 'pageOne',
            selectedModules: {},
        };
    },
    created() {
        const saved = loadFromLocalStorage().moduleSelectionsTwo || {};
        this.selectedModules = { ...saved };
    },
    methods: {
        handleFormValidity(isValid) {
            this.$emit('form-validity', isValid);
        },
        logFormState() {
            const data = loadFromLocalStorage();
            console.log('Current Form State:', JSON.stringify({
                ...data,
                moduleSelections: data.moduleSelections || {},
                moduleSelectionsTwo: data.moduleSelectionsTwo || {}
            }, null, 2));
        },
        nextPage() {
            this.logFormState();
            if (this.pageOne) {
                const homePage = this.$refs.homePage;
                if (homePage && homePage.validateForm()) {
                    this.pageOne = false;
                    this.pageTwo = true;
                }
            } else if (this.pageTwo) {
                this.pageTwo = false;
                this.pageThree = true;
            } else if (this.pageThree) {
                this.pageThree = false;
                this.pageFour = true;
            } else if (this.pageFour) {
                this.pageFour = false;
                this.pageFive = true;
            }
        },
        // nextPage() {
        //     this.logFormState();
        //     if (this.pageOne) {
        //         const homePage = this.$refs.homePage;
        //         if (homePage && homePage.validateForm()) {
        //             this.pageOne = false;
        //             this.pageTwo = true;
        //         }
        //     } else if (this.pageTwo) {
        //         this.pageTwo = false;
        //         this.pageThree = true;
        //     } else if (this.pageThree) {
        //         this.pageThree = false;
        //         this.pageFour = true;
        //     } else if (this.pageFour) {
        //         this.pageFour = false;
        //         this.pageFive = true;
        //     } else if (this.pageFive) {
        //         this.pageFive = false;
        //         this.pageSix = true;
        //     }
        // },
        previousPage() {
            this.logFormState();
            if (this.pageSix) {
                this.pageSix = false;
                this.pageFive = true;
            } else if (this.pageFive) {
                this.pageFive = false;
                this.pageFour = true;
            } else if (this.pageFour) {
                this.pageFour = false;
                this.pageThree = true;
            } else if (this.pageThree) {
                this.pageThree = false;
                this.pageTwo = true;
            } else if (this.pageTwo) {
                this.pageTwo = false;
                this.pageOne = true;
            }
        },
        handlePageChange(newPage) {
            Object.assign(formData.formState, this.$refs.content.getFormData());
            this.currentPage = newPage;
        },
        toggleCheckbox(event) {
            const moduleKey = event.target.dataset.module;
            if(moduleKey) {
                this.selectedModules[moduleKey] = !this.selectedModules[moduleKey];
                saveToLocalStorage({
                    moduleSelectionsTwo: this.selectedModules
                });
            }
        },
        saveAllData() {
            const formData = loadFromLocalStorage();
            saveToLocalStorage({
                ...formData,
                completedPages: { ...this.completedPages }
            });
        }
    },
    watch: {
        pageOne() {
            this.$emit('page-changed', 'pageOne');
        },
        pageTwo() {
            this.$emit('page-changed', 'pageTwo');
        },
        pageThree() {
            this.$emit('page-changed', 'pageThree');
        },
        pageFour() {
            this.$emit('page-changed', 'pageFour');
        },
        pageFive() {
            this.$emit('page-changed', 'pageFive');
        },
        pageSix() {
            this.$emit('page-changed', 'pageSix');
        },
        currentPage(newVal) {
            localStorage.setItem('currentStep', newVal);
            this.updateCompletedPages(newVal);
        }
    }
};
</script>
<style lang="scss">
#Content {
    width: 100%;
}
</style>